import { Device } from '../../../types/Device';

export function arraysEqual(a: Device[], b: Device[]) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
        if (a[i].UID !== b[i].UID) return false;
    }
    return true;
}
